import { render, staticRenderFns } from "./CollectionHome.vue?vue&type=template&id=aec58d6e&"
import script from "./CollectionHome.vue?vue&type=script&lang=js&"
export * from "./CollectionHome.vue?vue&type=script&lang=js&"
import style0 from "./CollectionHome.vue?vue&type=style&index=0&lang=scss&scope=app%2Fassets%2Fstylesheets%2Fcomponents%2Fcard-collection&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports